import React, { Component } from "react";

import UserService from "../services/user.service";

export default class Home extends Component {
  constructor(props) {
    super(props);

    this.state = {
      content: ""
    };
  }

  componentDidMount() {
    UserService.getPublicContent().then(
      response => {
        this.setState({
          content: response.data
        });
      },
      error => {
        this.setState({
          content:
            (error.response && error.response.data) ||
            error.message ||
            error.toString()
        });
      }
    );
  }

  render() {
    return (
      <div className="container">
{/*         <header className="jumbotron">
          <h3>{this.state.content}</h3>
        </header> */}
{/*         <div className="home-jumbotron jumbotron jumbotron-fluid bg-image">
        <div class="container">
          <h1 class="display-4 text-white">Welcome to our website!</h1>
          <p class="lead text-white">This is a simple hero unit, a simple jumbotron-style component for calling extra attention to featured content or information.</p>
          <hr class="my-4" />
          <p class="text-white">It uses utility classes for typography and spacing to space content out within the larger container.</p>
          <p class="lead">
            <a class="btn btn-primary btn-lg" href="#" role="button">Learn more</a>
          </p>
        </div>

        </div> */}
        
        <div className="home-jumbotron jumbotron jumbotron-fluid bg-image">
        <div class="container">
          <h1 class="display-4 text-white">Telegram Locations Collect</h1>

        </div>

        </div>

      </div>
    );
  }
}
